import { Button, Tooltip } from '@material-ui/core'
import { FeedbackOutlined } from '@material-ui/icons'
import { bomItemNameSelector } from 'features/BillOfMaterials/store/selectors/bomItemNameSelector'
import { bomItemRowNumberSelector } from 'features/BillOfMaterials/store/selectors/bomItemNumberSelector'
import { Issue } from 'model/IssueContext'
import { useTranslation } from 'react-i18next'
import { useAppSelector } from 'store/configureStore'
import { useAppDispatch } from 'store/configureStore'
import { AggregateLevel } from 'services/APIs/InternalAPI/internal-api.contracts'
import { ShowUserFeedbackForm } from 'store/Application/appActions'
import { RootAppState } from 'store/configureStore'
import { useOrganizationAndProjectContext } from 'utils/useOrganizationContext'
import { BomItemMenuItem } from './BomItemMenuItem'
import { bomItemUrlSelector } from 'features/BillOfMaterials/store/selectors/bomItemUrlSelector'

export const ReportRecognitionIssuesMenuItem = ({
  bomItemId,
  onClose,
  aggregateLevel,
  onClick,
  initialMessage = '',
  variant = 'menuItem',
  className,
}: {
  bomItemId: string
  onClose: () => void
  aggregateLevel?: AggregateLevel
  onClick?: () => void
  initialMessage?: string
  variant?: 'menuItem' | 'IconButton'
  className?: string
}) => {
  const currentUserEmail = useAppSelector(
    (state: RootAppState) => state.user?.profile?.email
  )

  const { partyId, projectId } = useOrganizationAndProjectContext()
  const partName = useAppSelector(bomItemNameSelector(bomItemId))
  const partUrl = useAppSelector(bomItemUrlSelector(bomItemId))
  const partRowNumber = useAppSelector(bomItemRowNumberSelector(bomItemId))
  const { t } = useTranslation()

  const dispatch = useAppDispatch()

  const issue: Issue = {
    message: initialMessage,
    tags: [],
    context: {
      organizationId: partyId,
      rowId: bomItemId,
      projectId: projectId,
      aggregateType: aggregateLevel || AggregateLevel.PartType,
      aggregateName: partName,
      rowNumber: partRowNumber,
      email: currentUserEmail,
      url: partUrl,
    },
  }

  if (variant === 'IconButton') {
    return (
      <Tooltip title={t('project:report-recognition-issues')}>
        <Button
          className={className}
          onClick={() =>
            dispatch(
              ShowUserFeedbackForm({
                show: true,
                issue,
              })
            )
          }
          endIcon={<FeedbackOutlined />}
        ></Button>
      </Tooltip>
    )
  }

  return (
    <BomItemMenuItem
      action={ShowUserFeedbackForm}
      actionParams={{
        show: true,
        issue,
      }}
      primaryTextTranslationKey="project:report-recognition-issues"
      secondaryTextTranslationKey="project:report-recognition-issues-description"
      icon={<FeedbackOutlined />}
      onClose={onClose}
      closeOnClick
      onClick={onClick}
    />
  )
}
